/*
 * @Date: 2023-10-07 15:19:29
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2023-10-17 17:22:25
 * @FilePath: \c-web-cli\packages\plugin-engine-saas\lib\utils\common.js
 */
import microApp from '@micro-zoe/micro-app'
import { IS_POWERED_BY_PLUGIN } from './constant'
export function getGlobalData (key) {
  let data = {}
  if (IS_POWERED_BY_PLUGIN) {
    data = window.microApp.getGlobalData() || {} // 获取全局数据
  }
  console.log('microApp.getGlobalData()', microApp.getGlobalData())
  console.log('window.microApp', window.microApp.getGlobalData())
  return data[key]
}

export function setGlobalData (data) {
  console.log('microApp.setGlobalData', data)
  microApp.setGlobalData(data)
}

// 区分环境生成cookie token name
export function getTokenName () {
  const hostname = window.location.hostname
  return hostname.indexOf('beta-') === 0 ? 'betaToken' : hostname.indexOf('dev-') === 0 ? 'devToken' : 'token'
}

// 获取cookie
export function getCookie (name) {
  let reg = RegExp(name + '=([^;]+)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return arr[1]
  } else {
    return ''
  }
}

export function genRandom () {
  return Math.floor(Math.random() * 10000000000)
}
